const welcomeDealSlugType = {
  DOG: '100-won-deal-dog',
  CAT: '100-won-deal-cat',
} as const

type WelcomeDealSlugKeyType = keyof typeof welcomeDealSlugType

export { welcomeDealSlugType }
export type { WelcomeDealSlugKeyType }
